var installedModules = {};
var moduleToHandlerMapping = {
	11042: {
		getter: () => (__webpack_require__.e(2176).then(() => (() => (__webpack_require__(72176))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.8.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	64518: {
		getter: () => (__webpack_require__.e(3172).then(() => (() => (__webpack_require__(83172))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.3.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	22134: {
		getter: () => (__webpack_require__.e(3989).then(() => (() => (__webpack_require__(43989))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.8.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	50846: {
		getter: () => (Promise.all([__webpack_require__.e(7012), __webpack_require__.e(6399)]).then(() => (() => (__webpack_require__(46399))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.1.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	13329: {
		getter: () => (__webpack_require__.e(9764).then(() => (() => (__webpack_require__(89764))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "14.1.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-i18next",
	},
	20911: {
		getter: () => (__webpack_require__.e(9784).then(() => (() => (__webpack_require__(59784))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"846": [
		50846
	],
	"986": [
		13329,
		20911
	],
	"1042": [
		11042
	],
	"2134": [
		22134
	],
	"4518": [
		64518
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}